import React, { useEffect, useState } from "react";
import { useSearcher } from "../../search/components/SearcherContext";
import { Dropdown, Form } from "semantic-ui-react";
import { ObjectProperty } from "../../object/components/ObjectPropertyList";
import ObjectLink from "../../object/components/ObjectLink";

export function personDisplayName(obj) {
  const nameSegments = [];
  if (obj.hasOwnProperty("FIRST_NAME")) {
    nameSegments.push(obj.FIRST_NAME[0]);
  }
  if (obj.hasOwnProperty("INITIALS") && !obj.hasOwnProperty("FIRST_NAME")) {
    nameSegments.push(obj.INITIALS[0]);
  }
  if (obj.hasOwnProperty("LAST_NAME")) {
    nameSegments.push(obj.LAST_NAME[0]);
  }
  return nameSegments.join(" ");
}

const PersonSelector = ({ search, section, onChange }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    search.searchObjectTypes("", "person", { section }).then(({ hits }) =>
      setOptions(
        hits.map(obj => ({
          key: obj.ID[0],
          value: obj.ID[0],
          text: personDisplayName(obj)
        }))
      )
    );
  }, [search, section]);

  return (
    <Dropdown
      placeholder="Select a person"
      search
      fluid
      selection
      clearable
      onChange={(e, { value }) => onChange(value)}
      options={options}
    />
  );
};

export const PersonFacetFilter = ({ section, header, onUpdate }) => {
  const search = useSearcher();
  const onPersonChange = id => {
    if (!id) {
      search.removeFilterPredicate({
        filterType: "A",
        fieldName: "PERSON"
      });
    } else {
      search.addFilter([
        {
          filterId: null,
          filterType: "A",
          fieldName: "PERSON",
          fieldValue: id
        }
      ]);
    }
    //call onUpdate if set
    onUpdate && onUpdate();
  };
  return (
    <Form.Field className="filter-field">
      {header}
      <PersonSelector
        search={search}
        section={section}
        onChange={onPersonChange}
      />
    </Form.Field>
  );
};

export const PersonLink = ({ obj, prop }) => {
  const person =
    obj.hasOwnProperty(prop.key) && obj[prop.key].length > 0
      ? obj[prop.key][0]
      : null;

  if (person === null) {
    return null;
  }

  // only Person ID available
  if (typeof person === "string") {
    return (
      <ObjectProperty label={prop.label || prop.key}>
        <ObjectLink id={person}>{person}</ObjectLink>
      </ObjectProperty>
    );
  }

  // person prop is object literal
  return (
    <ObjectProperty label={prop.label || prop.key}>
      <ObjectLink id={person["ID"]}>{personDisplayName(person)}</ObjectLink>
    </ObjectProperty>
  );
};

export default { Filter: PersonFacetFilter, Link: PersonLink };
